"use client";

import { c as _c } from "react/compiler-runtime";
import { NextIntlClientProvider } from "next-intl";
import type { ReactNode } from "react";
import type { Locale } from "@/i18n/routing";
import { unsafeKey } from "@/lib/i18n-keys";

// Client-side twin of i18n/request.ts. The layout resolves one locale's
// catalog on the server and hands it in, so the string tables (all 15
// languages, ~780 KB gzipped) never enter the client bundle. A key with no
// message renders as its English text instead of logging.
export default function IntlProvider(t0) {
  const $ = _c(4);
  const {
    locale,
    messages,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== locale || $[2] !== messages) {
    t1 = <NextIntlClientProvider locale={locale} messages={messages} timeZone="America/Los_Angeles" getMessageFallback={_temp} onError={_temp2}>{children}</NextIntlClientProvider>;
    $[0] = children;
    $[1] = locale;
    $[2] = messages;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp2(error) {
  if (error.code !== "MISSING_MESSAGE") {
    console.error(error);
  }
}
function _temp(t0) {
  const {
    key
  } = t0;
  return unsafeKey(key);
}